import { render, staticRenderFns } from "./WiringVoltages.vue?vue&type=template&id=b575e048&"
import script from "./WiringVoltages.vue?vue&type=script&lang=js&"
export * from "./WiringVoltages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports